(function () {
  if (window.__nsgProductConversionLoaded) return;
  window.__nsgProductConversionLoaded = true;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function cleanVariantLabel(label) {
    return String(label || '')
      .replace(/Logo12/g, 'Logo 12')
      .replace(/Sign16/g, 'Sign 16')
      .replace(/Sign28/g, 'Sign 28')
      .replace(/Sign32/g, 'Sign 32')
      .replace(/Storefront36/g, 'Storefront 36')
      .replace(/Storefront40/g, 'Storefront 40')
      .replace(/IN\//g, ' IN / ')
      .replace(/CM/g, ' CM')
      .replace(/Custom \(Upload\)/g, 'Custom size - upload logo')
      .replace(/Default Title/g, 'Custom project')
      .replace(/Nano plating/g, 'Plated metal finish')
      .replace(/Powder coat/g, 'Powder-coated finish')
      .replace(/RGB \(APP\)/g, 'RGB app control')
      .trim();
  }

  function getProductTitle() {
    var heading = document.querySelector('h1');
    if (heading && heading.textContent.trim()) {
      return heading.textContent.trim();
    }

    var analyticsProduct = window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product;

    if (analyticsProduct && analyticsProduct.title) {
      return analyticsProduct.title;
    }

    if (analyticsProduct && analyticsProduct.variants && analyticsProduct.variants[0]) {
      return cleanVariantLabel(analyticsProduct.variants[0].name || analyticsProduct.variants[0].public_title || '');
    }

    return '';
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function getProductHandleFromHref(href) {
    try {
      var url = new URL(href || '', window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function getRecommendationTitle(link) {
    var card = link.closest('product-card, .resource-list__item');
    var hiddenTitle = card && card.querySelector('.visually-hidden');
    var title = hiddenTitle ? hiddenTitle.textContent.trim() : '';
    if (title) return title;
    return (link.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function readStoredLeadContext() {
    var raw = '';
    try {
      raw = window.sessionStorage.getItem('nsg_product_lead_context_v1') ||
        window.localStorage.getItem('nsg_product_lead_context_v1') ||
        '';
    } catch (error) {
      raw = '';
    }

    if (!raw) return {};

    try {
      return JSON.parse(raw) || {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredLeadContext(context) {
    var serialized = JSON.stringify(context);
    try {
      window.sessionStorage.setItem('nsg_product_lead_context_v1', serialized);
      window.localStorage.setItem('nsg_product_lead_context_v1', serialized);
    } catch (error) {
      // Storage can be unavailable in private or restricted browsers.
    }
  }

  function getAttributionContext() {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'];
    var stored = readStoredLeadContext();
    var context = {};

    keys.forEach(function (key) {
      context[key] = getQueryParam(key) || stored[key] || '';
    });

    return context;
  }

  function buildLeadContext(extra) {
    var productTitle = getProductTitle();
    var productHandle = getProductHandle();
    var attribution = getAttributionContext();
    var stored = readStoredLeadContext();

    return Object.assign({
      product_title: productTitle || stored.product_title || '',
      product_handle: productHandle || stored.product_handle || getQueryParam('product') || '',
      product_url: productHandle ? window.location.origin + window.location.pathname : stored.product_url || '',
      page_path: window.location.pathname,
      page_title: document.title || '',
      source_page_path: stored.source_page_path || (productHandle ? window.location.pathname : ''),
      referrer: document.referrer || stored.referrer || '',
      source: getQueryParam('source') || stored.source || '',
      space_handle: getQueryParam('space') || stored.space_handle || '',
      collection_title: getQueryParam('collection_title') || stored.collection_title || '',
      quote_context: getQueryParam('quote_context') || stored.quote_context || '',
      quote_needs: getQueryParam('quote_needs') || stored.quote_needs || '',
      value_priority: getQueryParam('value_priority') || stored.value_priority || '',
      captured_at: new Date().toISOString()
    }, attribution, extra || {});
  }

  function persistLeadContext(extra) {
    var context = buildLeadContext(extra);
    writeStoredLeadContext(context);
    return context;
  }

  function isCustomSignProduct() {
    var path = window.location.pathname;
    var title = getProductTitle().toLowerCase();
    return path.indexOf('/products/') !== -1 &&
      (title.indexOf('custom') !== -1 || title.indexOf('sign') !== -1 || path.indexOf('sign') !== -1);
  }

  function isManualPaymentProduct() {
    var path = window.location.pathname.toLowerCase();
    var title = getProductTitle().toLowerCase();
    return path.indexOf('/products/') !== -1 &&
      (
        title.indexOf('design deposit') !== -1 ||
        title.indexOf('proof fee') !== -1 ||
        title.indexOf('final payment') !== -1 ||
        title.indexOf('payment link') !== -1 ||
        title.indexOf('remaining balance') !== -1 ||
        path.indexOf('design-deposit') !== -1 ||
        path.indexOf('proof-fee') !== -1 ||
        path.indexOf('final-payment') !== -1 ||
        path.indexOf('payment-link') !== -1
      );
  }

  function isNeonOpenFaceProduct() {
    var path = window.location.pathname.toLowerCase();
    var title = getProductTitle().toLowerCase();
    return title.indexOf('neon') !== -1 ||
      title.indexOf('open face') !== -1 ||
      title.indexOf('open-face') !== -1 ||
      path.indexOf('neon') !== -1 ||
      path.indexOf('open-face') !== -1;
  }

  function pushEvent(eventName, extra) {
    var params = Object.assign({
      page_path: window.location.pathname,
      product_title: getProductTitle(),
      product_handle: getProductHandle()
    }, extra || {});

    if (typeof window.nsgTrackEvent === 'function') {
      window.nsgTrackEvent(eventName, params);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName
    }, params));
  }

  function buildQuoteUrl(productTitle) {
    var productHandle = getProductHandle();
    var attribution = getAttributionContext();
    var params = new URLSearchParams();
    params.set('source', 'product_cta');
    params.set('quote_context', 'product_js_quote_cta');
    params.set('quote_needs', 'logo_wall_size_install_budget');
    params.set('value_priority', 'quality_creativity_service_value');
    if (productHandle) params.set('product', productHandle);
    if (productTitle) params.set('product_title', productTitle);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      var value = attribution[key];
      if (value) params.set(key, value);
    });
    return '/pages/contact?' + params.toString();
  }

  function buildLogoWallPhotoUrl(productTitle) {
    var productHandle = getProductHandle();
    var attribution = getAttributionContext();
    var params = new URLSearchParams();
    params.set('source', 'product_upload_cta');
    params.set('quote_context', 'product_js_upload_cta');
    params.set('quote_needs', 'logo_wall_size_install_budget');
    params.set('value_priority', 'quality_creativity_service_value');
    if (productHandle) params.set('product', productHandle);
    if (productTitle) params.set('product_title', productTitle);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      var value = attribution[key];
      if (value) params.set(key, value);
    });
    return '/pages/upload-logo-wall-photo?' + params.toString();
  }

  function getFitCompareOptions(productHandle) {
    var optionsByHandle = {
      'custom-front-lit-channel-letter-sign': [
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo'],
        ['custom-led-channel-letter-sign-restaurant-cafe', 'Restaurant / cafe letters'],
        ['custom-led-monument-pylon-sign-panel', 'Monument / pylon panel']
      ],
      'custom-3d-led-channel-letter-sign': [
        ['custom-front-lit-channel-letter-sign', 'Front-lit storefront letters'],
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo'],
        ['custom-led-channel-letter-sign-restaurant-cafe', 'Restaurant / cafe letters']
      ],
      'custom-front-lit-led-storefront-business-sign': [
        ['custom-front-lit-channel-letter-sign', 'Front-lit channel letters'],
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo'],
        ['custom-led-channel-letter-sign-restaurant-cafe', 'Restaurant / cafe letters']
      ],
      'custom-led-channel-letter-sign-restaurant-cafe': [
        ['custom-metal-open-face-led-neon-channel-letters', 'Open-face neon character'],
        ['custom-front-lit-channel-letter-sign', 'Front-lit storefront letters'],
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo']
      ],
      'custom-metal-open-face-led-neon-channel-letters': [
        ['custom-led-channel-letter-sign-restaurant-cafe', 'Restaurant / cafe letters'],
        ['custom-front-lit-channel-letter-sign', 'Front-lit storefront letters'],
        ['custom-backlit-logo-sign-restaurant-storefront', 'Backlit restaurant logo']
      ],
      'custom-outdoor-waterproof-led-logo-sign': [
        ['custom-front-lit-channel-letter-sign', 'Front-lit channel letters'],
        ['custom-outdoor-led-backlit-logo-sign', 'Outdoor backlit logo'],
        ['custom-led-monument-pylon-sign-panel', 'Monument / pylon panel']
      ],
      'custom-outdoor-led-backlit-logo-sign': [
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo'],
        ['custom-front-lit-channel-letter-sign', 'Front-lit channel letters'],
        ['custom-led-monument-pylon-sign-panel', 'Monument / pylon panel']
      ],
      'custom-led-monument-pylon-sign-panel': [
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo'],
        ['custom-front-lit-channel-letter-sign', 'Front-lit channel letters'],
        ['custom-backlit-logo-sign-restaurant-storefront', 'Backlit business logo']
      ],
      'custom-storefront-backlit-metal-logo-sign': [
        ['custom-led-backlit-logo-sign', 'Reception backlit logo'],
        ['custom-front-lit-channel-letter-sign', 'Street-facing channel letters'],
        ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo']
      ],
      'custom-led-backlit-logo-sign': [
        ['custom-office-reception-halo-backlit-logo-sign', 'Office / reception halo'],
        ['custom-storefront-backlit-metal-logo-sign', 'Premium logo wall'],
        ['custom-front-lit-channel-letter-sign', 'Storefront channel letters']
      ],
      'custom-office-reception-halo-backlit-logo-sign': [
        ['custom-led-backlit-logo-sign', 'Reception backlit logo'],
        ['custom-storefront-backlit-metal-logo-sign', 'Premium logo wall'],
        ['custom-stainless-steel-halo-backlit-logo-sign', 'Stainless steel halo']
      ]
    };

    return optionsByHandle[productHandle] || [
      ['custom-front-lit-channel-letter-sign', 'Front-lit channel letters'],
      ['custom-led-backlit-logo-sign', 'Reception backlit logo'],
      ['custom-outdoor-waterproof-led-logo-sign', 'Outdoor waterproof logo']
    ];
  }

  function buildFitCompareUrl(targetHandle) {
    var url = new URL('/products/' + encodeURIComponent(targetHandle), window.location.origin);
    var attribution = getAttributionContext();

    url.searchParams.set('source', 'product_fit_compare');
    url.searchParams.set('quote_context', 'product_fit_compare');
    url.searchParams.set('quote_needs', 'logo_wall_size_install_budget');
    url.searchParams.set('value_priority', 'quality_creativity_service_value');
    url.searchParams.set('source_product', getProductHandle());

    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      var value = attribution[key];
      if (value) url.searchParams.set(key, value);
    });

    return url.pathname + url.search;
  }

  function renderFitCompareHtml() {
    var productHandle = getProductHandle();
    var options = getFitCompareOptions(productHandle).filter(function (option) {
      return option[0] && option[0] !== productHandle;
    }).slice(0, 3);

    if (!options.length) return '';

    return [
      '<div class="nsg-product-fit-compare">',
      '<p class="nsg-product-fit-compare__label">Not sure this is the right sign type?</p>',
      '<div class="nsg-product-fit-compare__links">',
      options.map(function (option) {
        return '<a class="nsg-product-fit-compare__link" href="' + buildFitCompareUrl(option[0]) + '" data-nsg-product-event="product_fit_compare_click" data-nsg-event-source="product_fit_compare" data-nsg-product-handle="' + option[0] + '" data-nsg-product-title="' + option[1] + '">' + option[1] + '</a>';
      }).join(''),
      '</div>',
      '</div>'
    ].join('');
  }

  function appendProductContext(url, productTitle) {
    var productHandle = getProductHandle();
    var attribution = getAttributionContext();

    if (productHandle) {
      url.searchParams.set('product', productHandle);
    }
    if (productTitle) {
      url.searchParams.set('product_title', productTitle);
    }
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      var value = attribution[key];
      if (value && !url.searchParams.get(key)) {
        url.searchParams.set(key, value);
      }
    });
  }

  function normalizeQuoteHref(href, productTitle) {
    var url;

    try {
      url = new URL(href || '/pages/contact', window.location.origin);
    } catch (error) {
      return buildQuoteUrl(productTitle);
    }

    url.pathname = '/pages/contact';
    if (!url.searchParams.get('source')) {
      url.searchParams.set('source', 'product_cta');
    }
    if (!url.searchParams.get('quote_context')) {
      url.searchParams.set('quote_context', 'product_js_quote_cta');
    }
    if (!url.searchParams.get('quote_needs')) {
      url.searchParams.set('quote_needs', 'logo_wall_size_install_budget');
    }
    if (!url.searchParams.get('value_priority')) {
      url.searchParams.set('value_priority', 'quality_creativity_service_value');
    }
    appendProductContext(url, productTitle);

    return url.pathname + url.search;
  }

  function normalizeLogoWallPhotoHref(href, productTitle) {
    var url;

    try {
      url = new URL(href || '/pages/upload-logo-wall-photo', window.location.origin);
    } catch (error) {
      return buildLogoWallPhotoUrl(productTitle);
    }

    url.pathname = '/pages/upload-logo-wall-photo';
    if (!url.searchParams.get('source')) {
      url.searchParams.set('source', 'product_upload_cta');
    }
    if (!url.searchParams.get('quote_context')) {
      url.searchParams.set('quote_context', 'product_js_upload_cta');
    }
    if (!url.searchParams.get('quote_needs')) {
      url.searchParams.set('quote_needs', 'logo_wall_size_install_budget');
    }
    if (!url.searchParams.get('value_priority')) {
      url.searchParams.set('value_priority', 'quality_creativity_service_value');
    }
    appendProductContext(url, productTitle);

    return url.pathname + url.search;
  }

  function normalizeExistingCtas() {
    var productTitle = getProductTitle();
    var links = Array.prototype.slice.call(document.querySelectorAll('a'));

    links.forEach(function (link) {
      var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      var lowerText = text.toLowerCase();
      var href = link.getAttribute('href') || '';

      if (
        href.indexOf('/pages/upload-logo-wall-photo') !== -1 ||
        href.indexOf('/pages/email-logo-wall-photo') !== -1 ||
        lowerText === 'email logo & wall photo' ||
        lowerText === 'upload logo / wall photo' ||
        lowerText === 'email logo / wall photo'
      ) {
        link.setAttribute('href', normalizeLogoWallPhotoHref(href, productTitle));
        link.setAttribute('data-nsg-product-event', 'logo_wall_photo_cta_click');
        link.setAttribute('data-nsg-event-source', link.getAttribute('data-nsg-event-source') || 'product_page');
        link.setAttribute('data-nsg-product-handle', getProductHandle());
        link.setAttribute('data-nsg-product-title', productTitle);
      }

      if (
        href.indexOf('/pages/contact') !== -1 ||
        lowerText === 'request a quote' ||
        lowerText === 'request custom quote' ||
        lowerText === 'request project quote' ||
        lowerText.indexOf('request a quote') !== -1 ||
        href.indexOf('mailto:design@nervesign.com') === 0
      ) {
        if (href.indexOf('/pages/contact') === -1) {
          link.textContent = 'Request Custom Quote';
        }
        link.setAttribute('href', normalizeQuoteHref(href, productTitle));
        link.setAttribute('data-nsg-product-event', 'quote_cta_click');
        link.setAttribute('data-nsg-event-source', link.getAttribute('data-nsg-event-source') || 'product_page');
        link.setAttribute('data-nsg-product-handle', getProductHandle());
        link.setAttribute('data-nsg-product-title', productTitle);
      }
    });
  }

  function normalizeTrackedProductLinks() {
    var attribution = getAttributionContext();
    var stored = readStoredLeadContext();
    var links = Array.prototype.slice.call(document.querySelectorAll('a[data-nsg-product-event][href*="/products/"]'));

    links.forEach(function (link) {
      var url;
      try {
        url = new URL(link.getAttribute('href') || '', window.location.origin);
      } catch (error) {
        return;
      }

      if (url.pathname.indexOf('/products/') === -1) return;

      var eventSource = inferProductLinkSource(link) ||
        getQueryParam('source') ||
        stored.source ||
        'tracked_product_link';
      var quoteContext = inferProductLinkSource(link) ||
        getQueryParam('quote_context') ||
        stored.quote_context ||
        eventSource;
      var quoteNeeds = getQueryParam('quote_needs') ||
        stored.quote_needs ||
        'logo_wall_size_install_budget';
      var valuePriority = getQueryParam('value_priority') ||
        stored.value_priority ||
        'quality_creativity_service_value';

      if (!url.searchParams.get('source')) {
        url.searchParams.set('source', eventSource);
      }
      if (!url.searchParams.get('quote_context')) {
        url.searchParams.set('quote_context', quoteContext);
      }
      if (!url.searchParams.get('quote_needs')) {
        url.searchParams.set('quote_needs', quoteNeeds);
      }
      if (!url.searchParams.get('value_priority')) {
        url.searchParams.set('value_priority', valuePriority);
      }

      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'].forEach(function (key) {
        var value = attribution[key];
        if (value && !url.searchParams.get(key)) {
          url.searchParams.set(key, value);
        }
      });

      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function normalizeLeadCtaAttribution() {
    var attribution = getAttributionContext();
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'];
    var hasProductContext = isCustomSignProduct();
    var productTitle = hasProductContext ? getProductTitle() : '';
    var hasAttribution = keys.some(function (key) {
      return !!attribution[key];
    });
    if (!hasAttribution && !hasProductContext) return;

    var links = Array.prototype.slice.call(document.querySelectorAll('a[href*="/pages/contact"], a[href*="/pages/upload-logo-wall-photo"]'));
    links.forEach(function (link) {
      var url;

      try {
        url = new URL(link.getAttribute('href') || '', window.location.origin);
      } catch (error) {
        return;
      }

      keys.forEach(function (key) {
        if (attribution[key] && !url.searchParams.get(key)) {
          url.searchParams.set(key, attribution[key]);
        }
      });

      if (hasProductContext) {
        appendProductContext(url, productTitle);
      }

      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function observeDynamicQuoteLinks() {
    if (!window.MutationObserver || !document.body) return;

    var pending = false;
    var observer = new MutationObserver(function (mutations) {
      var shouldNormalize = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('a[href*="/pages/contact"], a[href*="/pages/upload-logo-wall-photo"], a[href*="/products/"]')) return true;
          return !!(node.querySelector && node.querySelector('a[href*="/pages/contact"], a[href*="/pages/upload-logo-wall-photo"], a[href*="/products/"]'));
        });
      });

      if (!shouldNormalize || pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        normalizeLeadCtaAttribution();
        if (isCustomSignProduct()) {
          normalizeExistingCtas();
        }
        normalizeTrackedProductLinks();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function inferProductLinkSource(link) {
    if (!link || !link.closest) return '';

    var explicitSource = link.getAttribute('data-nsg-event-source') || '';
    if (explicitSource) return explicitSource;

    if (link.closest('product-recommendations')) {
      return 'product_recommendations';
    }

    if (link.closest('.product-grid-container')) {
      return 'collection_product_card';
    }

    if (link.closest('.nsg-seo-vertical')) {
      return 'seo_product_card';
    }

    return 'product_card';
  }

  function enhancePriceAndCta() {
    var productPrice = document.querySelector('product-price');
    var price = productPrice ?
      productPrice.querySelector('.price') :
      document.querySelector('[ref="priceContainer"] .price, .price');

    if (!price || price.closest('[data-nsg-enhanced-panel]')) return;

    var priceBlock = price.closest('product-price') || price.closest('[ref="priceContainer"]') || price.parentElement;
    if (!priceBlock || priceBlock.getAttribute('data-nsg-price-enhanced') === 'true') return;

    var rawPrice = price.textContent.trim();
    var normalizedPrice = rawPrice.toLowerCase();
    var alreadyQuoteFirst = normalizedPrice.indexOf('quote') !== -1 ||
      normalizedPrice.indexOf('estimate') !== -1 ||
      normalizedPrice.indexOf('review') !== -1;

    if (alreadyQuoteFirst) {
      price.textContent = rawPrice || 'Custom quote after review';
    } else if (rawPrice && isNeonOpenFaceProduct() && /\$50(?:\.00)?\b/.test(rawPrice)) {
      price.textContent = 'Custom quote after review';
    } else if (rawPrice && rawPrice.toLowerCase().indexOf('starting at') === -1) {
      price.textContent = 'Starting at ' + rawPrice;
    }
    priceBlock.setAttribute('data-nsg-price-enhanced', 'true');

    var productTitle = getProductTitle();
    var priceNote = isNeonOpenFaceProduct() ?
      '<strong>Open-face neon projects are quoted around the real storefront or interior feature wall.</strong> Final pricing depends on size, colors, letter depth, mounting, power access, and site conditions.' :
      '<strong>Final quote depends on size, finish, lighting, mounting method, artwork complexity, and site conditions.</strong> Use Request Custom Quote first so the estimate is built around the real sign project.';

    var panel = document.createElement('div');
    panel.className = 'nsg-price-cta-panel';
    panel.setAttribute('data-nsg-enhanced-panel', 'true');
    panel.innerHTML = [
      '<div class="nsg-product-cta-actions">',
      '<a class="nsg-product-cta nsg-product-cta-primary" href="' + buildQuoteUrl(productTitle) + '" data-nsg-product-event="quote_cta_click" data-nsg-event-source="product_page">Request Custom Quote</a>',
      '<a class="nsg-product-cta nsg-product-cta-secondary" href="#nsg-chat" data-nsg-contact-open data-nsg-contact-source="product_page_cta" data-nsg-chat-method="contact_hub">Message Us</a>',
      '<a class="nsg-product-cta nsg-product-cta-secondary" href="' + buildLogoWallPhotoUrl(productTitle) + '" data-nsg-product-event="logo_wall_photo_cta_click" data-nsg-event-source="product_page">Upload Logo / Wall Photo</a>',
      '</div>',
      renderFitCompareHtml(),
      '<p class="nsg-price-note">' + priceNote + '</p>',
      '<ul class="nsg-product-proof-list" aria-label="Project confidence points">',
      '<li>Free design proof</li>',
      '<li>Production timing confirmed after proof, site, and scope review</li>',
      '<li>Indoor and outdoor build options</li>',
      '<li>France / EU shipping reviewed by quote first, including import VAT, duties, permits, and local electrical requirements</li>',
      '<li>Payment after quote review by draft order or payment link</li>',
      '</ul>'
    ].join('');

    priceBlock.insertAdjacentElement('afterend', panel);
  }

  function enhanceManualPaymentProduct() {
    var productPrice = document.querySelector('product-price');
    var price = productPrice ?
      productPrice.querySelector('.price') :
      document.querySelector('[ref="priceContainer"] .price, .price');

    if (!price || price.closest('[data-nsg-manual-payment-note]')) return;

    var priceBlock = price.closest('product-price') || price.closest('[ref="priceContainer"]') || price.parentElement;
    if (!priceBlock || priceBlock.getAttribute('data-nsg-manual-payment-enhanced') === 'true') return;

    var title = getProductTitle().toLowerCase();
    var isFinalPayment = title.indexOf('final payment') !== -1 ||
      title.indexOf('remaining balance') !== -1 ||
      window.location.pathname.toLowerCase().indexOf('final-payment') !== -1;
    var note = isFinalPayment ?
      '<strong>Pay this only after quote review and proof approval.</strong> This final payment link should match the written quote for your approved custom sign project.' :
      '<strong>This is not the final sign price.</strong> The design deposit or proof fee starts artwork/proof review only. Production starts after final quote confirmation and proof approval.';

    var panel = document.createElement('div');
    panel.className = 'nsg-price-cta-panel';
    panel.setAttribute('data-nsg-manual-payment-note', 'true');
    panel.innerHTML = [
      '<p class="nsg-price-note">' + note + '</p>',
      '<ul class="nsg-product-proof-list" aria-label="Payment terms">',
      '<li>Use only after a Nerve Sign quote or payment link is sent</li>',
      '<li>Project details stay tied to the approved quote and proof</li>',
      '<li>Contact Nerve Sign before paying if the amount or project scope looks different</li>',
      '</ul>'
    ].join('');

    priceBlock.setAttribute('data-nsg-manual-payment-enhanced', 'true');
    priceBlock.insertAdjacentElement('afterend', panel);
  }

  function pauseDirectCheckout() {
    var addButton = document.querySelector('button[name="add"]');
    var stickyAddToCart = document.querySelector('sticky-add-to-cart');

    if (addButton) {
      var buyBlock = addButton.closest('.buy-buttons-block') || addButton.closest('product-form-component');
      var previous = buyBlock ? buyBlock.previousElementSibling : null;
      var alreadyHasHelper = previous && previous.classList && previous.classList.contains('nsg-buy-helper');
      if (buyBlock && !alreadyHasHelper) {
        var helper = document.createElement('div');
        helper.className = 'nsg-buy-helper';
        helper.innerHTML = [
          '<strong>Custom signage is quoted before checkout.</strong>',
          '<span>Design deposits, proof fees, and final balances are paid only after manual quote review through a Shopify draft order or payment link. France / EU projects should use Request Quote first so shipping terms, import VAT or duties, permits, and electrical requirements are confirmed before production.</span>'
        ].join('');
        buyBlock.insertAdjacentElement('beforebegin', helper);
      }

      if (buyBlock && buyBlock.getAttribute('data-nsg-direct-checkout-paused') !== 'true') {
        buyBlock.setAttribute('data-nsg-direct-checkout-paused', 'true');
        buyBlock.setAttribute('hidden', 'hidden');
        buyBlock.classList.add('nsg-direct-checkout-paused');
      }
    }

    if (stickyAddToCart && stickyAddToCart.getAttribute('data-nsg-direct-checkout-paused') !== 'true') {
      stickyAddToCart.setAttribute('data-nsg-direct-checkout-paused', 'true');
      stickyAddToCart.setAttribute('hidden', 'hidden');
    }
  }

  function hideInlineProductPropertyFields() {
    var propertyFields = Array.prototype.slice.call(document.querySelectorAll('product-custom-property-component'));

    propertyFields.forEach(function (field) {
      field.setAttribute('data-nsg-quote-property-paused', 'true');
      field.setAttribute('hidden', 'hidden');
    });
  }

  function markLongCopy() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('rte-formatter'));
    blocks.forEach(function (block) {
      var text = block.textContent || '';
      if (text.length > 900 && text.indexOf('UL-certified') !== -1) {
        block.classList.add('nsg-long-product-copy');
      }
    });
  }

  function syncPrivacyBannerOffset() {
    var root = document.documentElement;
    var media = window.matchMedia('(max-width: 749px)');
    var observedBanner = null;
    var resizeObserver = null;
    var ticking = false;

    function getBanner() {
      return document.querySelector('#shopify-pc__banner');
    }

    function observeBanner() {
      var banner = getBanner();
      if (banner === observedBanner) return;

      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }

      observedBanner = banner;

      if (banner && window.ResizeObserver) {
        resizeObserver = new ResizeObserver(requestUpdate);
        resizeObserver.observe(banner);
      }
    }

    function update() {
      ticking = false;
      observeBanner();

      var banner = getBanner();
      var bannerRect = banner ? banner.getBoundingClientRect() : null;
      var bannerStyle = banner ? window.getComputedStyle(banner) : null;
      var isVisible = media.matches &&
        banner &&
        bannerRect.height > 0 &&
        bannerStyle.display !== 'none' &&
        bannerStyle.visibility !== 'hidden';

      if (!isVisible) {
        root.classList.remove('nsg-product-privacy-banner-visible');
        root.style.removeProperty('--nsg-product-privacy-banner-height');
        return;
      }

      root.classList.add('nsg-product-privacy-banner-visible');
      root.style.setProperty('--nsg-product-privacy-banner-height', Math.ceil(bannerRect.height) + 'px');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    var mutationObserver = new MutationObserver(requestUpdate);
    mutationObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'id', 'style'],
      childList: true,
      subtree: true
    });

    if (media.addEventListener) {
      media.addEventListener('change', requestUpdate);
    } else if (media.addListener) {
      media.addListener(requestUpdate);
    }
    window.addEventListener('resize', requestUpdate);
    window.setTimeout(requestUpdate, 300);
    window.setTimeout(requestUpdate, 1200);
    requestUpdate();
  }

  function renderMobileProductQuoteBar() {
    if (document.querySelector('[data-nsg-mobile-product-bar]')) return;

    var productTitle = getProductTitle();
    var bar = document.createElement('div');
    bar.className = 'nsg-mobile-product-quote-bar';
    bar.setAttribute('data-nsg-mobile-product-bar', 'true');
    bar.setAttribute('data-visible', 'false');
    bar.setAttribute('aria-label', 'Product quote shortcuts');
    bar.innerHTML = [
      '<a class="nsg-mobile-product-quote-bar__button" href="' + buildQuoteUrl(productTitle) + '" data-nsg-product-event="quote_cta_click" data-nsg-event-source="mobile_sticky_product_quote">Request Quote</a>',
      '<a class="nsg-mobile-product-quote-bar__upload" href="' + buildLogoWallPhotoUrl(productTitle) + '" data-nsg-product-event="logo_wall_photo_cta_click" data-nsg-event-source="mobile_sticky_product_upload">Upload Files</a>'
    ].join('');

    document.documentElement.classList.add('nsg-has-mobile-product-bar');
    document.body.appendChild(bar);
    syncMobileProductQuoteBar(bar);
  }

  function syncMobileProductQuoteBar(bar) {
    var primaryCtaActions = document.querySelector('.nsg-price-cta-panel .nsg-product-cta-actions');
    if (!primaryCtaActions) {
      bar.setAttribute('data-visible', 'true');
      return;
    }

    var ticking = false;

    function update() {
      ticking = false;
      if (!window.matchMedia('(max-width: 749px)').matches) {
        bar.setAttribute('data-visible', 'false');
        return;
      }

      var rect = primaryCtaActions.getBoundingClientRect();
      var safeBottom = window.innerHeight - 112;
      var primaryCtaVisible = rect.bottom > 96 && rect.top < safeBottom;
      bar.setAttribute('data-visible', primaryCtaVisible ? 'false' : 'true');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  function wireEvents() {
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      var recommendationLink = event.target.closest('product-recommendations a[href*="/products/"]');
      if (recommendationLink) {
        var linkedProductHandle = getProductHandleFromHref(recommendationLink.getAttribute('href'));
        var sourceProductHandle = getProductHandle();
        if (linkedProductHandle && linkedProductHandle !== sourceProductHandle) {
          var linkedProductTitle = getRecommendationTitle(recommendationLink);
          var recommendationContext = persistLeadContext({
            event_source: 'product_recommendations',
            source: 'product_recommendations',
            product_handle: sourceProductHandle,
            product_title: getProductTitle(),
            linked_product_handle: linkedProductHandle,
            linked_product_title: linkedProductTitle,
            linked_product_url: window.location.origin + '/products/' + encodeURIComponent(linkedProductHandle),
            source_page_path: window.location.pathname,
            quote_context: 'product_recommendations',
            quote_needs: getQueryParam('quote_needs') || 'logo_wall_size_install_budget',
            value_priority: getQueryParam('value_priority') || 'quality_creativity_service_value'
          });
          pushEvent('product_recommendation_click', {
            event_source: 'product_recommendations',
            source_product_handle: sourceProductHandle,
            source_product_title: getProductTitle(),
            linked_product_handle: linkedProductHandle,
            linked_product_title: linkedProductTitle,
            linked_product_url: recommendationContext.linked_product_url || '',
            source_page_path: window.location.pathname,
            quote_context: recommendationContext.quote_context || '',
            quote_needs: recommendationContext.quote_needs || '',
            value_priority: recommendationContext.value_priority || '',
            utm_source: recommendationContext.utm_source || '',
            utm_medium: recommendationContext.utm_medium || '',
            utm_campaign: recommendationContext.utm_campaign || '',
            gclid: recommendationContext.gclid || ''
          });
        }
      }

      var trigger = event.target.closest('[data-nsg-product-event]');
      if (!trigger) return;
      var triggerProductHandle = trigger.getAttribute('data-nsg-product-handle') || getProductHandle() || getQueryParam('product') || '';
      var triggerProductTitle = trigger.getAttribute('data-nsg-product-title') || getProductTitle();
      var triggerSource = trigger.getAttribute('data-nsg-event-source') || inferProductLinkSource(trigger) || getQueryParam('source') || '';
      var eventContext = {
        event_source: triggerSource,
        source: triggerSource,
        product_handle: triggerProductHandle,
        product_title: triggerProductTitle,
        linked_product_title: triggerProductTitle,
        source_page_path: window.location.pathname,
        space_handle: trigger.getAttribute('data-nsg-space-handle') || getQueryParam('space') || '',
        collection_title: trigger.getAttribute('data-nsg-collection-title') || getQueryParam('collection_title') || '',
        quote_context: triggerSource || getQueryParam('quote_context') || 'product_interaction',
        quote_needs: getQueryParam('quote_needs') || 'logo_wall_size_install_budget',
        value_priority: getQueryParam('value_priority') || 'quality_creativity_service_value'
      };
      if (triggerProductHandle) {
        eventContext.product_url = window.location.origin + '/products/' + encodeURIComponent(triggerProductHandle);
      }
      var context = persistLeadContext(eventContext);
      pushEvent(trigger.getAttribute('data-nsg-product-event'), {
        event_source: context.event_source || '',
        linked_product_title: context.linked_product_title || '',
        product_handle: context.product_handle || '',
        product_title: context.product_title || '',
        space_handle: context.space_handle || '',
        collection_title: context.collection_title || '',
        quote_context: context.quote_context || '',
        quote_needs: context.quote_needs || '',
        value_priority: context.value_priority || '',
        source_page_path: context.source_page_path || '',
        utm_source: context.utm_source || '',
        utm_medium: context.utm_medium || '',
        utm_campaign: context.utm_campaign || '',
        gclid: context.gclid || ''
      });
    });
  }

  function setInputValue(input, value, overwrite) {
    if (!input || value === undefined || value === null || value === '') return;
    if (!overwrite && input.value) return;
    input.value = value;
  }

  function hydrateLeadFormsFromStoredContext() {
    var params = new URLSearchParams(window.location.search);
    var context = readStoredLeadContext();
    var map = {
      source: 'source',
      product: 'product_handle',
      product_title: 'product_title',
      variant: 'variant_id',
      space: 'space_handle',
      collection_title: 'collection_title',
      utm_source: 'utm_source',
      utm_medium: 'utm_medium',
      utm_campaign: 'utm_campaign',
      utm_term: 'utm_term',
      utm_content: 'utm_content',
      gclid: 'gclid',
      gbraid: 'gbraid',
      wbraid: 'wbraid'
    };

    document.querySelectorAll('[data-nsg-param]').forEach(function (input) {
      var key = input.getAttribute('data-nsg-param');
      var contextKey = map[key] || key;
      setInputValue(input, params.get(key) || context[contextKey] || '', false);
    });

    document.querySelectorAll('[data-nsg-context]').forEach(function (input) {
      var key = input.getAttribute('data-nsg-context');
      setInputValue(input, context[key] || '', false);
    });

    document.querySelectorAll('[data-nsg-page-path]').forEach(function (input) {
      setInputValue(input, window.location.pathname, true);
    });

    document.querySelectorAll('[data-nsg-full-query]').forEach(function (input) {
      setInputValue(input, window.location.search ? window.location.search.slice(1) : '', true);
    });
  }

  ready(function () {
    if (isCustomSignProduct()) {
      var storedOnProductLoad = readStoredLeadContext();
      persistLeadContext({
        source: getQueryParam('source') || storedOnProductLoad.source || 'product_page_view',
        quote_context: getQueryParam('quote_context') || storedOnProductLoad.quote_context || 'product_page_view',
        quote_needs: getQueryParam('quote_needs') || storedOnProductLoad.quote_needs || 'logo_wall_size_install_budget',
        value_priority: getQueryParam('value_priority') || storedOnProductLoad.value_priority || 'quality_creativity_service_value'
      });
    }
    hydrateLeadFormsFromStoredContext();
    normalizeLeadCtaAttribution();
    normalizeTrackedProductLinks();
    observeDynamicQuoteLinks();
    window.setTimeout(function () {
      normalizeLeadCtaAttribution();
      normalizeTrackedProductLinks();
    }, 800);
    window.setTimeout(function () {
      normalizeLeadCtaAttribution();
      normalizeTrackedProductLinks();
    }, 1800);
    window.setTimeout(function () {
      normalizeLeadCtaAttribution();
      normalizeTrackedProductLinks();
    }, 3200);
    wireEvents();

    if (isManualPaymentProduct()) {
      enhanceManualPaymentProduct();
      return;
    }
    if (!isCustomSignProduct()) return;
    enhancePriceAndCta();
    normalizeExistingCtas();
    pauseDirectCheckout();
    hideInlineProductPropertyFields();
    markLongCopy();
    renderMobileProductQuoteBar();
    syncPrivacyBannerOffset();
    window.setTimeout(function () {
      normalizeLeadCtaAttribution();
      normalizeExistingCtas();
    }, 600);
    window.setTimeout(function () {
      normalizeLeadCtaAttribution();
      normalizeExistingCtas();
    }, 1600);
    window.setTimeout(function () {
      normalizeLeadCtaAttribution();
      normalizeExistingCtas();
    }, 3200);
  });
})();
